module.exports = __webpack_public_path__ + "static/media/IconANT.a380dc8d.svg";